import { AlertComponentModule } from '@b2b/common/components/alert';
import { CartDirectiveModule } from '@b2b/common/directives/cart';
import { CartItemDirectiveModule } from '@b2b/common/directives/cartItem';
import { OrderSummaryDirectiveModule } from '@b2b/common/directives/order/summary';
import { VCardDirectiveModule } from '@b2b/common/directives/vcard';
import { LoadACMECheckoutResolver, ThemesDataResolver, TenantDataResolver } from '@b2b/common/resolvers';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { CartMembershipComponentModule } from './components/cart-membership/cart-membership.component';
import { CartControllerModule } from './controllers/CartController';

export const CartView = angular
  .module('acme.view.application.cart', [
    uiRouter,
    'ui.bootstrap',
    VCardDirectiveModule,
    OrderSummaryDirectiveModule,
    CartItemDirectiveModule,
    CartDirectiveModule,
    'acme.common.service.api',
    CartControllerModule,
    CartMembershipComponentModule,
    AlertComponentModule,
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const cart = {
      name: 'application.cart',
      url: '/cart',
      views: {
        'subview-main': {
          controller: 'CartController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/cart/cart.tpl.html',
        },
      },
      data: {
        pageTitle: 'Cart',
        pageClass: 'application application-cart',
        /** Secure With Permissions **/
        permissions: ['EVENT_VIEW'],
      },
      resolve: {
        ThemesData: ThemesDataResolver({ includeEmail: true }),
        ACMECheckout: LoadACMECheckoutResolver(),
        TenantData: TenantDataResolver(),
      },
    };

    $stateProvider.state(cart);
  }).name;
